/**
 * Styled Components - Created by cazarez on 02/05/18.
 */
import styled from 'styled-components'
import Button from 'antd/lib/button'
import { BLUE, WHITE, GRAY_DARK, GRAY_LIGHT, BLUE_BRIGHT } from '../../theme/colors'
import { AVENIR_NEXT } from '../../theme/fonts'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const Text = styled.div`
  color: #fff;
`

export const StyledButton = styled(Button)`
  height: 50px;
  width: 221px;
  background-color: ${BLUE};
  border-color: ${BLUE};
  border-radius: 2px;
  text-transform: uppercase;
  color: ${WHITE} !important;
  transition: all 0.25s;
  &:hover,
  :focus,
  :active {
    background-color: ${BLUE_BRIGHT};
    border-color: ${BLUE_BRIGHT};
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

interface ButtonContainerProps {
  withoutTop?: boolean
  myLockerList?: boolean
  fullWidth?: boolean
}

export const ButtonContainer = styled.div`
  user-select: none;
  display: flex !important;
  position: ${({ myLockerList }: ButtonContainerProps) =>
    myLockerList ? 'relative' : 'absolute'};
  justify-content: center;
  top: ${({ withoutTop, myLockerList }: ButtonContainerProps) => {
    if (myLockerList) {
      return '0'
    }
    return withoutTop ? '5px' : '170px'
  }};
  margin-bottom: ${({ myLockerList }: ButtonContainerProps) => (myLockerList ? '4px' : '0px')};
`

export const ProjectContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex !important;
  position: absolute;
  width: 100%;
  top: calc(40% - 38px);
  opacity: 0.95;
  & > div {
    width: 70% !important;
  }
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: ${AVENIR_NEXT};
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 12px 0 12px -38px;
`

export const CustomizeButton = styled.div`
  user-select: none;
  background-color: #179ce6e0;
  color: #fff;
  font-size: ${({ fullWidth }: ButtonContainerProps) => (fullWidth ? '10px' : '12px')};
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: ${({ fullWidth }: ButtonContainerProps) => (fullWidth ? '6px 69px' : '6px 19px')};

  @media (min-width: 320px) and (max-width: 768px) {
    background-color: ${BLUE};
    color: ${WHITE};
    width: 100%;
    padding: ${({ fullWidth }: ButtonContainerProps) => (fullWidth ? '8px 40px' : '6px 19px')};
  }

  transition: all .25s;
  ${({ disabled }: Prop) => disabled ? `
    background: #bcbcbce0;
    color: #625f5f;
  ` : ''}
  &:hover {
    cursor: pointer;
    filter: brightness(1.1);
  }
`

export const MenuItem = styled.div`
  padding: 10px 12px;
  margin: -10px -12px;
  color: #6f8471;
`

export const MenuIcon = styled(Icon)`
  margin-right: 10px;
  color: #92ae95;
`

interface Prop {
  individual?: boolean
  disabled?: boolean
  secondary?: boolean
  hide?: boolean
}

export const ButtonWrapper = styled.span`
  display: ${({ hide }: Prop) => (hide ? 'none' : 'flex')};
  align-self: flex-end;
  font-size: 16px;
  letter-spacing: 0.11px;
  line-height: 22px;
  transition: all .3s;
  width: ${({ individual, secondary }: Prop) => (individual && !secondary ? '93px' : '145px')};
  margin-left: ${({ secondary }: Prop) => secondary ? '16px' : 'auto'};
  @media (min-width: 320px) and (max-width: 480px) {
    margin-top: ${({ individual }: Prop) => (individual ? '5px' : '0px')};
    width: ${({ individual }: Prop) => (individual ? '139px' : '145px')};
  }

  .ant-btn-primary {
    background-color: ${BLUE};
    border-color: ${BLUE};
  }
  .ant-btn-primary:hover {
    background-color: ${BLUE};
    border-color: ${BLUE};
  }
`
export const ReorderButton = styled(Button)`
  width: 100%;
`

export const AddFromApproval = styled(Button)`
  width: 100%;
  background-color: #6b9dd8;
  border-color: #6b9dd8;
  color: ${WHITE};
  transition: all .25s;
  width: 100%;
  max-width: 164px;
  height: 40px;
  border-radius: 3px;
  &:hover {
    cursor: pointer;
    border-color: ${BLUE};
    background-color: ${WHITE};
    color: ${BLUE};
  }
`

export const buttonStyle = {
  background: BLUE,
  color: WHITE,
  border: 'none',
  boxShadow: 'none'
}

export const cancelButtonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}

export const ButtonStoreContainer = styled.div<{$fromStore?: boolean}>`
  user-select: none;
  display: flex !important;
  justify-content: center;
  width: 100%;
  margin-bottom: ${({ myLockerList }: ButtonContainerProps) => (myLockerList ? '4px' : '0px')};
  ${props => props.$fromStore ? `
    @media (max-width: 698px) {
      width: unset;
      margin-left: 10px;
      margin-right: 6px;
    }
  ` : ''};
`

export const CustomizeStoreButton = styled.div`
  user-select: none;
  background-color: #2b2b2c;
  color: #fff;
  box-shadow: 0px 1px 2px 0px #d3d3d3;
  font-family: var(--font-barlow);
  font-size: ${({ fullWidth }: ButtonContainerProps) => (fullWidth ? '10px' : '12px')};
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: ${({ fullWidth }: ButtonContainerProps) => (fullWidth ? '5px 69px' : '8px 19px')};
  width: 100%;
  @media (min-width: 320px) and (max-width: 768px) {
    background-color: #2b2b2c;
    color: ${WHITE};
    width: 100%;
    padding: ${({ fullWidth }: ButtonContainerProps) => (fullWidth ? '8px 40px' : '6px 19px')};
  }

  transition: all .25s;
  ${({ disabled }: Prop) => disabled ? `
    background: #bcbcbce0;
    color: #625f5f;
  ` : ''}

  .anticon {
    margin-right: 8px;
    font-size: 14px;
  }
  &:hover {
    cursor: pointer;
    background: var(--neutral-body);
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AddToCartButton/styledComponents.tsx